// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

// Estado para agrupar las escrituras de estilo del zoom en un frame. El navegador
// dispara mousemove varias veces por cuadro; aplicar los estilos en cada uno hace
// trabajo que nunca llega a pintarse y fuerza recálculos de layout entre lecturas.
// Guardando el último valor y escribiéndolo una sola vez por frame se obtiene el
// mismo resultado visible con mucho menos trabajo en el hilo principal.
let magnifyFrame = null;
let magnifyPendingStyles = null;

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  // Se guarda junto con su overlay: entre que se agenda el frame y que se
  // ejecuta, el overlay pudo haberse cerrado y vuelto a abrir, y en ese caso
  // corresponde escribir sobre el que originó la medición.
  magnifyPendingStyles = {
    overlay: overlay,
    backgroundPosition: `${xPercent} ${yPercent}`,
    backgroundSize: `${image.width * zoomRatio}px`,
  };

  if (magnifyFrame !== null) return;
  magnifyFrame = requestAnimationFrame(() => {
    magnifyFrame = null;
    const pending = magnifyPendingStyles;
    magnifyPendingStyles = null;
    if (!pending || !pending.overlay) return;
    pending.overlay.style.backgroundPosition = pending.backgroundPosition;
    pending.overlay.style.backgroundSize = pending.backgroundSize;
  });
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
